import { DataRetentionSettingsGetters } from './partials/dataRetention'
import { DocketwiseSettingsGetters } from './partials/docketwise'
import { EngagementLetterGetters } from './partials/engagementLetter'
import { GenericModelSettingsGetters } from './partials/genericModel'
import { InvoicedSettingsGetters } from './partials/invoiced'
import { LegalCasePartySliderSettingsGetters } from './partials/legalCasePartySlider'
import { LegalCasesSettingsGetters } from './partials/legalCases'
import { MaintenanceSettingsGetters } from './partials/maintenance'
import { MiscSettingsGetters } from './partials/misc'
import { MultifactorAuthenticationSettingsGetters } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsGetters } from './partials/otherDocketEntries'
import { PermissionsSettingsGetters } from './partials/permissions'
import { RecordsSettingsGetters } from './partials/records'
import { SessionManagementSettingsGetters } from './partials/sessionManagement'
import { SettingsSharedGetters } from './partials/shared'
import { SharepointSettingsGetters } from './partials/sharepoint'
import { TimezoneSettingsGetters } from './partials/timezone'
import { TmetricSettingsGetters } from './partials/tmetric'
import { TwilioSettingsGetters } from './partials/twilio'
import { UserAccessSettingsGetters } from './partials/usersAccess'
import { UserSettingsGetters } from './partials/user'
import { WorkflowSettingsGetters } from './partials/workflows'

export const SettingsGetters = {
  ...DataRetentionSettingsGetters,
  ...DocketwiseSettingsGetters,
  ...EngagementLetterGetters,
  ...GenericModelSettingsGetters,
  ...InvoicedSettingsGetters,
  ...LegalCasePartySliderSettingsGetters,
  ...LegalCasesSettingsGetters,
  ...MaintenanceSettingsGetters,
  ...MiscSettingsGetters,
  ...MultifactorAuthenticationSettingsGetters,
  ...OtherDocketEntriesSettingsGetters,
  ...PermissionsSettingsGetters,
  ...RecordsSettingsGetters,
  ...SessionManagementSettingsGetters,
  ...SettingsSharedGetters,
  ...SharepointSettingsGetters,
  ...TimezoneSettingsGetters,
  ...TmetricSettingsGetters,
  ...TwilioSettingsGetters,
  ...UserAccessSettingsGetters,
  ...UserSettingsGetters,
  ...WorkflowSettingsGetters,
}
